// Page dictionary for insights-archive.html.
// English is the page's own HTML; main.js merges these over its shared dict.
window.FORSYT_PAGE_I18N = {
  "fr": {
    "archive.eyebrow": "Archives des insights",
    "archive.title": "Toutes les analyses",
    "archive.subtitle": "Les analyses de marché, études de cas et actualités produit de Forsyt, de la plus récente à la plus ancienne."
  },
  "de": {
    "archive.eyebrow": "Insights Archiv",
    "archive.title": "Alle Analysen",
    "archive.subtitle": "Marktanalysen, Fallstudien und Produktneuigkeiten von Forsyt, von der neuesten zur ältesten."
  }
};
